function JoyTycoonMain(app,conf,user_state) {
  this.app = new PIXI.Application({
    width:1280,height:780,antialias:true,transparent:true,
    view:app[0]
  });
  conf=$.extend(true,{
        "girl_ids":[1,2,3],
        "toysConfig":{
            "1":{pos:[17,419],anchor:[0,0]},
            "2":{pos:[206,420],anchor:[0,0]},
            "3":{pos:[7,580],anchor:[0,0]},
            "4":{pos:[149,578],anchor:[0,0]},
        },
        "factoryConfig":{
            "1":{pos:[279,578],anchor:[0,0]},
            "2":{pos:[546,578],anchor:[0,0]},
            "3":{pos:[665,578],anchor:[0,0]}
        },
        "addFactoryConfig":{
            "1":{pos:[516,60]},
            "2":{pos:[626,60]},
            "3":{pos:[758,52]}
        },
        "plateConfig":{
            containerPos:[0,0],
            plate_count:0,
        },
        "plateConfigItems":{
            "1":{pos:[303,475],size:[189,108],anchor:[0,0]},
            "2":{pos:[728,477],size:[187,106],anchor:[0,0]},
            "3":{pos:[462,473],size:[150,101],anchor:[0,0]},
            "4":{pos:[607,473],size:[150,100],anchor:[0,0]}  
        },
      
      
  },conf);
  
  var th = this;
  this.config = conf;
  this.storage={
      customer_id_max:0,//id to find customer
      delta_sort:0,
      bonus:this.config.general.bonus,
      state:"game",//tutorial stops the game
      tutorial_arr:copyArray(this.config.tutorial),
      tutorial_need:{},
      tutorial_have:{"type":"",id:0,"add_ids":[],sent:0},
      timeout:0,
      user_state:user_state
  };
  this.state={
      points:user_state.points,
      points_need:this.config.general.points_need,
      was_cum:0,
      tutorial:0
  };
  
  
  this.objects={};
  this.containerSet={};
  this.customers=[];
  
  this.customersDrawCustom={};
  this.customersDrawCustomToDel=[];
  this.tents=[];
  this.customersSlots = {
      "1":{blocked:0,pos:[100,0],slot_id:1},
      "2":{blocked:0,pos:[320,0],slot_id:2},
      "3":{blocked:0,pos:[540,0],slot_id:3}
  };
   this.tentSlots = {
      "1":{blocked:0,pos:[790,0],slot_id:1},
      "2":{blocked:0,pos:[1010,0],slot_id:2},
//      "3":{blocked:0,pos:[1150,0],slot_id:3}
  };
  this.indexKeys={
        "customer":_moduleTimeHandler.getNewIndex(),
        "lose":_moduleTimeHandler.getNewIndex(),
  };
  this.needBlock={};
  this.delta_sum=0;
  this.resources;
  this.girlIds=conf.girl_ids;
  
  this.addCustomerHandlerIndex=null;
  this.customerIdsToDel={};
  
  this.pointsAllEarned = 0;
  this.customersAll = 0;
  this.statesAll;
  this.plateObj;
  this.tentSet;
  this.iceArr=[];
  this.otherAnim=[];
  this.timerBox;
  this.comboBox;
  this.pointBox;
  this.cumBox;
  this.tutorialArrow;
  
  this.canAddToTent=true;
  
  
  _moduleEvents.on("moduleClear",function () {
    th.myDestruct(th);
  });
}
JoyTycoonMain.prototype = {
    init:function (resources,states) {
        var thc = this;
        var user_state=this.storage.user_state;
        this.resources=resources;
        this.setContainers();
        this.setCoversImages();

        this.plateObj=new JoyTycoonPlace(this.config.plateConfig,this.config.plateConfigItems);

        this.statesAll = states;
        

        

        var maxCustomers = this.config.customers_max;
        var maxObj = 4,bum,i;
        for(i in this.config.toysConfig){
          bum = this.config.toysConfig[i];
          bum.id=bum.toy_id;
          bum.type="toy";
//          bum = $.extend(true,this.config.toyOrderConf[bum.order_id],bum);
          bum.containerPos = this.containerSet["toy"].takeContainerPos();
          var obj = new JoyTycoonObject(bum);
          this.objects["toy"+bum.id] = obj;
          this.needBlock["toy"+bum.id]={type:"toy",id:bum.id,delta:0};
          this.containerSet["toy"].addChild(obj);
        }
        this.containerSet["plate"].addChild(this.plateObj);
        this.insertFactoryAdd();
        var howlong=this.config.general.howlong;
        if(user_state.points>0){
            howlong=user_state.howlong_remain;
        }
        this.timerBox= new JoyTycoonTimerBox({
            pos:[344,0],
            capText:"TIME!",
            howlong:(howlong),
            onEnd:function(){
                thc.storage.timeout=1;
            }
        });
        this.containerSet.uiFront.addChild(this.timerBox);
        
        this.comboBox= new JoyTycoonComboBox({
            capText:"BONUS",
            howmany:user_state.heart,
            pos:[1100,0]
        });
        this.containerSet.uiFront.addChild(this.comboBox);
        this.pointBox=new JoyTycoonPointBox({
            capText:"POINTS",
            pos:[922,0],
            howmany:user_state.points,
            howmany_max:this.state.points_need
        });
        this.containerSet.uiFront.addChild(this.pointBox);
        
        
        this.tentSet= new JoyTycoonSpineSet({slotCount:3},resources);
        this.containerSet["tent"].addChild(this.tentSet);
        this.cumSet= new JoyTycoonSpineSet({slotCount:1},resources);
        this.containerSet["uiFront"].addChild(this.cumSet);
        this.cumBox=new JoyTycoonCumBox({
            live_max:this.config.general.live_max,
            pos:[1280,530]
        },resources);
        this.containerSet["uiFront"].addChild(this.cumBox);
        this.tutorialArrow=new myPixiElement.arrow({img:"tutorial_arrow",angle:180});
        this.tutorialArrow.alpha=0;
        this.containerSet["tutorial"].addChild(this.tutorialArrow);
    },
    insertFactoryAdd:function(){
        var i,bum;            
        for (i in this.config.factory){
            bum=copyObj(this.config.factory[i]);
            bum.id=bum.factory_id;
            if(typeof this.objects["factory"+bum.id]=="undefined"){
                bum.type="factory";
                bum.containerPos = this.containerSet["factory"].takeContainerPos();
                var obj = new JoyTycoonObject(bum,this.config.factoryConfig[bum.id]);
                this.objects["factory"+bum.id] = obj;
                this.containerSet["factory"].addChild(obj);
            }
        }
        for (i in this.config.add){
            bum=copyObj(this.config.add[i]);
            bum.id=bum.add_id;
            if(typeof this.objects["add"+bum.id+"_factory"]=="undefined"){
                
                bum.type="add";
                bum.containerPos = this.containerSet["addfactory"].takeContainerPos();
                bum.img=bum.img+"_factory";
                var obj = new JoyTycoonObject(bum,this.config.addFactoryConfig[bum.id]);
                this.objects["add"+bum.id+"_factory"] = obj;
                this.containerSet["addfactory"].addChild(obj);
            }
        }       
    },
    startGame:function(div){
        var thc=this;
        this.plateObj.init();
        this.timerBox.addHowlong(this.storage.user_state.howlong_add);
        this.setTouch(div);
        this.addCustomerHandlerIndex = _moduleTimeHandler.add(function () {
            thc.addCustomer({wait:0});
        },this.config.general.customer_mili_next);
        
        this.app.ticker.add(function (delta) {
            thc.myUpdate(delta);
        })
    },
    randCustomerTypeId:function () {
        var randMax=0,rand,typeId=0,curr=0;
        for (var i in this.config.customersConfig) {
            randMax += this.config.customersConfig[i].chance;
        }

        rand = mt_rand(1,randMax);
        for (var i in this.config.customersConfig) {
            curr += this.config.customersConfig[i].chance;
            if (curr>=rand) {
              typeId = i;
              break;
            }
        }
        if (!typeId) {
            return;
        }

        return intval(typeId);
    },
    setCoversImages:function () {



    },
    setContainers:function () {
        var containerSet={
            "tent":{pos:[0,0]},
            "customer":{pos:[0,360]},
            "combo":{pos:[200,900]},
            "ui":{pos:[0,0]},
            "cover1":{pos:[0,0]},
            "toy":{pos:[0,0]},
            "cover2":{pos:[0,0]},
            "factory":{pos:[0,0]},
            
            "plate":{pos:[0,0]},
            
            "uiFront":{pos:[0,0]},
            "addfactory":{pos:[0,0]},
            "otherAnim":{pos:[0,0]},
            "tutorial":{pos:[0,0]},
        };
        
        
        var key,bum;
        for(key in containerSet){
            bum=containerSet[key]
            this.containerSet[key]= new myPixiElement.container();
            this.containerSet[key].x=bum.pos[0];
            this.containerSet[key].y=bum.pos[1];
            this.app.stage.addChild(this.containerSet[key]);
        }
        this.containerSet["ui"].addChild(new myPixiElement.img({img:"cover_all",anchor:[0,0]}));
        this.containerSet["cover2"].addChild(new myPixiElement.img({img:"down_center",anchor:[0,1],pos:[218,780]}));
        this.containerSet.uiFront.addChild(new myPixiElement.img({img:"creamCover",anchor:[0.5,0],pos:[640,0]}));
    },
    takeCustomer:function(customer_id){
        var i,bum;
        for(i in this.customers){
            bum=this.customers[i];
            if(bum.takeId()==customer_id){
                return bum;
            }
        }
        return false;
    },
    findCustomerWhoNeed:function(need){
        
        var i,bum,customer,res,need_arr=[];
        
        var customer_id;
        for(i in this.customers){
            customer=this.customers[i];
            res=customer.checkIfNeed(need);
            if(res.res==1){
                need_arr.push(res);
            }
        }
        if(need_arr.length>0){
            need_arr.sort(function(a,b){
                return a.busyTime-b.busyTime;
            });
            res=need_arr[0];
            customer_id=res.customer_id;
            customer=this.takeCustomer(customer_id);
            if(customer!==false){
                return customer;
            }
        }
        return false;
    },
    
    
    addCustomer:function (opt) {
        if(typeof opt=="undefined"){
            opt={};
        }
        opt=$.extend(true,{wait:this.config.general.customer_mili_break},opt);
        
        var thc=this;
        
        if(this.storage.timeout && !this.state.tutorial){
            return false;
        }
        
        if(opt.wait>0){
            if(_moduleTimeHandler.isIndexSet(this.indexKeys.customer)){
                return false;
            }
            else{
                _moduleTimeHandler.setOne(this.indexKeys.customer,function(){
                    thc.addCustomer();
                },opt.wait);
                return true;
            }
        }
        var customer_count_max=this.config.general.girls_count;
        if(this.storage.tutorial_arr.length>0){
            customer_count_max=1;
        }
        if(this.customers.length>=customer_count_max){
            return false;
        }
        
        var thc=this;
        
        var x=0;
        var i,bum,arr=[];
        
        for(i in this.customersSlots) {
            bum=this.customersSlots[i];
            if(bum.blocked==0){
                arr.push(bum.slot_id);
            }
        }
        if(arr.length==0){
            return false;
        }
        var slot=this.customersSlots[arr[mt_rand(0,arr.length-1)]];
        slot.blocked=1;
        
        var type_id=this.randCustomerTypeId();
        
        this.storage.customer_id_max++;
        var customer = new JoyTycoonCustomer(type_id,{
            customer_id:this.storage.customer_id_max,
            girl_id:mt_rand(1,this.config.general.customer_id_max),
            slot_id:slot.slot_id,
            combo_part:this.config.general.combo_part,
            tutorial_mode:this.state.tutorial,
            resources:this.resources,
            onCombo:function(pos){
                thc.comboBox.addHeart(1);
                var pos_end=thc.comboBox.takeTextPos();//takeContainerPos
                var moveObj = new myPixiObj.drawCustom({
                    pos_start:pos,
                    pos_end:pos_end,
                    v:15,
                    img:"combo_happy",
//                    scale_arr:[100,55],
//                    scaleTo:[obj.config.width,obj.config.height],
                    onEndAnim:function(){
                    }

                });
                thc.containerSet["otherAnim"].addChild(moveObj);
                thc.otherAnim.push(moveObj);
            }
        },this.config);
        
        this.customers.push(customer);
        var pos_start = [-customer.takeSize()[0],0],
        pos_end = slot.pos;
        customer.posStart = pos_end;
        
        customer.x=-customer.takeSize()[0];
        customer.y=0;
        //moveToPos
        
        customer.moveToPos({pos_end:pos_end},function(){
            var toyBlocked=[],i,bum;
            for(i in thc.needBlock){
                bum=thc.needBlock[i];
                if(bum.type=="toy"){
                    toyBlocked.push({type:bum.type});
                }
            }
            var tutorial_need={};
            if(thc.storage.tutorial_arr.length){
                tutorial_need=thc.storage.tutorial_arr.shift();
                thc.startTutorial(tutorial_need);
            }
            
            this.onFirstMoveEnd({
                onTimerEnd:function(){
                    thc.customerLoose(customer);
                    thc.sortClients(1);
                },
                tutorial_need:tutorial_need
            });
        });
        this.containerSet["customer"].addChild(customer);
        return true;
    },
    
    prepareTutorialMode:function(tutorial_arr){
        this.state.tutorial=1;
        this.storage.tutorial_arr=copyArray(tutorial_arr);
        this.timerBox.alpha=0;
        this.comboBox.alpha=0;
        this.pointBox.alpha=0;
        this.config.factoryConfig=$.extend(true,this.config.factoryConfig,{
            "1":{"factory_id":1,"howlong":2,"need_factory_ids":[],pos:[279,578],anchor:[0,0]},
            "2":{"factory_id":2,"howlong":2,"need_factory_ids":[],pos:[546,578],anchor:[0,0]},
            "3":{"factory_id":3,"howlong":1,"need_factory_ids":[2],pos:[665,578],anchor:[0,0]},
        });//initial this.config.factoryConfig was empty... WHY???
        this.config.factory={
            "1": {img: "factory1", factory_id: 1},
            "2": {img: "factory2", factory_id: 2},
            "3": {img: "factory3", factory_id: 3}
        };
        this.config.add={
            "1": {img: "add1", add_id: 1},
            "2": {img: "add2", add_id: 2},
            "3": {img: "add3", add_id: 3}
        };
        this.config.iceConfig={
            "1":{"ice_id":1,"factory_ids":[1],"add_ids":[1],img: "ice1"},
            "2":{"ice_id":2,"factory_ids":[2,3],"add_ids":[2,3],img: "ice2"},
        };
        this.plateObj.config.plate_count=4;
        this.insertFactoryAdd();        
    },
    startTutorial:function(need){
        this.storage.state="tutorial";
        this.tutorialArrow.alpha=1;
        this.storage.tutorial_need=need;
        
        var have=this.storage.tutorial_have;
        if(need.type=="ice"){
            need.factory_ids=copyArray(this.config.iceConfig[need.id].factory_ids);
            have.factory_ids=[];
        }
        this.showTutorial();
    },
    showTutorial:function(){
        var need=this.storage.tutorial_need;
        var have=this.storage.tutorial_have;
        var opt={pos:[0,0],angle:180}
        if(need.type=="toy"){
            opt.pos=this.objects["toy"+need.id].takePos([0.5,0]);
        }
        else if(need.type=="ice"){
            
            var i,bum,id;
            for(i in need.factory_ids){
                id=need.factory_ids[i];
                if(!in_array(id,have.factory_ids)){
                    have.factory_id_wait=id;
                    break;
                }
            }
            if(have.factory_id_wait>0){
                opt.pos=this.objects["factory"+have.factory_id_wait].takePos([0.5,0]);
                if(have.factory_id_wait!=2){
                    opt.pos[1]+=60;
                }
            }
            else if(need.add_ids.length && !arrayAreEqual(need.add_ids,have.add_ids)){
                for(i in need.add_ids){
                    id=need.add_ids[i];
                    if(!in_array(id,have.add_ids)){
                        opt.pos=this.objects["add"+id+"_factory"].takePos([0,0.5]);
                        opt.angle=0;
                        break;
                    }
                }
            }
            else{
                var state;
                for(i in this.iceArr){
                    bum=this.iceArr[i];
                    state=bum.takeState();
                    if(bum.isNeed(need)){
                        opt.pos=bum.takePos();
                        opt.pos[1]-=110;
                        break
                    } 
                }
            }
            
        }
        this.tutorialArrow.updateSet(opt);
    },
    canEndTutorial:function(){
        var need=this.storage.tutorial_need,
        have=this.storage.tutorial_have;
        if(need.type==have.type && have.sent==1 && need.id==have.id && arrayAreEqual(need.add_ids,have.add_ids)){
            return true;
        } 
        return false;
    },
    tryEndTutorial:function(){
        var need=this.storage.tutorial_need,
        have=this.storage.tutorial_have;
        if(need.type=="ice"){
            if(arrayAreEqual(need.factory_ids,have.factory_ids)){
                have.type="ice";
                have.id=need.id;
            }
        }
        
        if(this.canEndTutorial()){
            this.tutorialArrow.alpha=0;
            if(this.storage.tutorial_arr.length==0){
            }
            this.storage.state="game";
            this.storage.tutorial_have={"type":"",id:0,"add_ids":[],sent:0};
            if(this.state.tutorial && this.storage.tutorial_arr.length==0){
                var thc=this;
                _moduleTimeHandler.addOne(function(){
                    thc.statesAll.endTutorial();
                },500);
            }
        }
        else{
            this.showTutorial();
        }
    },
    sortClients:function(force){
        if(force || this.delta_sum-this.storage.delta_sort>30){
            this.storage.delta_sort=this.delta_sum;
            this.containerSet["customer"].children.sort(function(a,b) {
                return b.x - a.x;
            });
        }
        
    },
  /*
   * obj -> joyTycoonObject
   */
  clickFactory:function(obj){
    var thc=this;
    var factory_id=obj.takeId();
    if(this.storage.state=="tutorial"){
        if(this.storage.tutorial_have.factory_id_wait==factory_id){
            this.tutorialArrow.alpha=0;
        }
        else{
            return false;
        }
    }
    var ice_id=this.findIceId("factory_ids",factory_id);
    var i,ice,state;
    if(obj.config.need_factory_ids.length){
        //find existing
        for(i in this.iceArr){
            ice=this.iceArr[i];
            state=ice.takeState();
            if(state.type=="" && state.id==ice_id && ice.blockFactory(factory_id)){
                obj.makeBusy(obj.config.howlong,function(){
                    ice.releaseFactory();
                    if(thc.storage.state=="tutorial"){
                        thc.storage.tutorial_have.factory_ids.push(factory_id);
                        thc.storage.tutorial_have.factory_id_wait=0;
                        thc.tryEndTutorial();
                        thc.tutorialArrow.alpha=1;
                    }
                });
                break;
            }
        }

    }
    else{
        //try add new ice;
        var plate=this.plateObj.findFree();
        if(plate.res!=0){
            var res=obj.makeBusy(obj.config.howlong,function(){
                var iceConf={
                    pos:plate.pos,
                    ice_id:ice_id,
                    factory_ids:[factory_id],
                    plate_index:plate.res,
                    need:{factory_ids:thc.config.iceConfig[ice_id].factory_ids}
                };
                var ice=new JoyTycoonIce(iceConf);
                thc.iceArr.push(ice);
                thc.containerSet["plate"].addChild(ice);
                if(thc.storage.state=="tutorial"){
                    thc.storage.tutorial_have.factory_ids.push(factory_id);
                    thc.storage.tutorial_have.factory_id_wait=0;
                    thc.tryEndTutorial();
                    thc.tutorialArrow.alpha=1;
                }
            });
            if(res){
                this.plateObj.setBusy(plate.res);
            }

        }
    }

  },
    giveNeedToCustomer:function(customer,need){
        var res=customer.blockNeed(need);
        if(customer.needSomething()){
            customer.releaseItem();
        }
        else{
            customer.releaseBusy();
        }
        return res;
    },
    
    clickOnIce:function(obj){
        var thc=this;
        var need=obj.takeState();
        if(need.type==""){
            return false;
        }
        
        
        var customer=this.findCustomerWhoNeed(need);
        if(customer===false){
            return false;
        }
        if(this.storage.state=="tutorial" && !obj.isNeed(this.storage.tutorial_need)){
            return false;
        }
        var res=this.giveNeedToCustomer(customer,need);
        this.plateObj.setFree(obj.takePlateIndex());

        var pos_need=addVector(customer.takePosObjectCointainer(),res.pos);
        pos_need=addVector([this.containerSet["customer"].x,this.containerSet["customer"].y],pos_need);
        pos_need=addVector(pos_need,[customer.x,customer.y]);
        
        if(this.storage.state=="tutorial"){
            this.storage.tutorial_have.sent=1;
            this.tryEndTutorial();
        }

        obj.moveToPos({pos_end:pos_need},function(){
            customer.giveNeed(need);
            if(customer.canEndNeed()){
                thc.customerDecide(customer);                     
            }
        });
    },
    endTent:function(customer){

        var thc=this;
        
        var slot_id=this.tentSet.findReady();
        var move=1;
        if(slot_id>0){
            move=0;
        }
        this.customerScore(customer,{move:move});
        if(slot_id>0){
            if(!customer.wasFail()){
                var girl_id=customer.takeGirlId();
                this.tentSet.playAnim({slot_id:slot_id,img:"customer"+girl_id+"_tent"+slot_id});
                customer.fadeOut(20,{
                    onEnd:function(){

                        thc.customerDeleteFromMemory(customer);

                    }
                });
            }
            else{
                $.qLog(" EPIC FAIL=> Zgłoś Michałowi, PROSZĘ. Nie przeladowuj ekranu.. ");
            }
        }
        else{
            
        }
        
        
        
//        var key="c"+customer.takeId();
//        thc.customersDrawCustom[key].fadeOut(20,{
//            onEnd:function(){
//                thc.customerDeleteFromMemory(customer);
//            }
//        });
        
    },
    clickAdd:function(obj){
        var add_id=obj.takeId(),ice_id;
        var i,bum,need;
        for(i in this.config.iceConfig){
            bum=this.config.iceConfig[i];
            if(in_array(add_id,bum.add_ids)){
                ice_id=bum.ice_id;
            }
        }
        if(this.storage.state=="tutorial"){
            if(!in_array(add_id,this.storage.tutorial_need.add_ids) || in_array(add_id,this.storage.tutorial_have.add_ids)){
                return false;
            }
        }
        var can_add_arr=[];
        for(i in this.iceArr){
            bum=this.iceArr[i];
            need=bum.takeState();
            if(need.type=="ice" && need.id==ice_id && !in_array(add_id,need.add_ids)){
                can_add_arr.push({key:i,count:need.add_ids.length});
            }
        }
        if(can_add_arr.length==0){
            return false;
        }
        can_add_arr.sort(function(a,b){
           return b.count-a.count; 
        });
        var ice=this.iceArr[can_add_arr[0].key];
        
        
        ice.giveAddId(add_id);
        
        if(this.storage.state=="tutorial"){
            this.storage.tutorial_have.add_ids.push(add_id);
            this.tryEndTutorial();
        }
        
    },
    /*
     * obj -> joyTycoonObject
     */
    clickToy:function (obj) {
        var thc=this;
        var toy_id=obj.takeId();
        var need={type:"toy",id:toy_id,add_ids:[]};


        var customer=this.findCustomerWhoNeed(need);
        if(customer===false){
            this.objects["toy"+need.id].makeBusy();
            return false;
        }
        if(this.storage.state=="tutorial"){
            var tutorial_need=this.storage.tutorial_need;
            if(tutorial_need.id==toy_id){
                this.storage.tutorial_have={type:"toy",id:toy_id,add_ids:[],sent:1};
                this.tryEndTutorial();
            }
            else{
                return false;
            }
        }
        
        
        var res=this.giveNeedToCustomer(customer,need);
        this.objects["toy"+need.id].makeBusy();

        var pos_need=addVector(customer.takePosObjectCointainer(),res.pos);
        pos_need=addVector([this.containerSet["customer"].x,this.containerSet["customer"].y],pos_need);
        pos_need=addVector(pos_need,[customer.x,customer.y]);

        var tutorial_need=this.storage.tutorial_need;
       

        var pos=this.objects["toy"+need.id].takePos([0.5,0.5]);



       var moveObj = new myPixiObj.drawCustom({
            pos_start:pos,
            pos_end:pos_need,
            v:10,
            img:"toy"+need.id,
            scale_arr:[100,55],
            scaleTo:[obj.config.width,obj.config.height],
            onEndAnim:function(){
                var res=customer.giveNeed(need);
                if(typeof res.type!="undefined" && res.type=="tent"){
                    thc.endTent(customer);
                }
                else{
                    if(customer.canEndNeed()){
                        
                        thc.customerDecide(customer);  
                    }
                }
                
                
                this.storage.active=1;
                this.pause();
                this.fadeOut(20,{onEnd:function(){
                    this.storage.dontKillOnStop=0;
                }});
            }

        });
        this.containerSet["otherAnim"].addChild(moveObj);
        this.otherAnim.push(moveObj);

        return false;
    
    
    },
    customerDeleteFromMemory:function(customer){
        var thc=this;
        
        var slot_id=customer.freeTentSlot();
        if(slot_id){
            thc.tentSlots[slot_id].blocked=0;
        }
        thc.customers.splice(thc.customers.indexOf(customer),1);
    },
    customerGoOut:function(customer,conf){
        conf=$.extend(true,{
            hate:0,
            onDelete:function(){}
        },conf);
        var thc=this;
        customer.moveToPos({
            pos_end:[1400,customer.y],
               hate:conf.hate 
            },function(){
                conf.onDelete();
                thc.customerDeleteFromMemory(customer);
            }
        );
    },
    customerLoose:function(customer){
        if(customer.takeState()=="need"){
            this.customersSlots[customer.config.slot_id].blocked=0;
        }
        var thc=this;
        customer.lose();
        
        this.addCustomer();
        var girl_id=customer.takeGirlId();
        var slot_id=this.cumSet.findReady();
        
        if(!this.cumBox.getLive()){
            this.state.was_cum=1;
        }
        
        
        
        
        if(slot_id>0){
            this.cumSet.playAnim({slot_id:slot_id,img:"customer"+girl_id+"_cum"+mt_rand(1,2)});
            customer.fadeOut(20,{
                onEnd:function(){
                    thc.customerDeleteFromMemory(customer);
                    if(thc.state.was_cum){
                        thc.endGameNow();
                    }
                }
            });
        }
        else{
            this.customerGoOut(customer,{
                hate:1,
                onDelete:function(){
                    if(thc.state.was_cum){
                        thc.endGameNow();
                    }
                }
            });
        }
        
        
        
        
    },
    customerScore:function(customer,opt){
        opt=$.extend(true,{move:1},opt);
        if(opt.move){
            this.customerGoOut(customer);
        }
        var points=20;
        points=Math.round(points*this.comboBox.takeBonus()*customer.takeBonus()/100/100*this.storage.bonus);
        this.state.points+=points;
        
        this.pointBox.addPoints(points);
    },
    customerTent:function(customer,slot){
        var thc=this;
        
        var i,bum,obj;
        
        
        slot.blocked=true;//is set later
       
        
        
        
        var to_set={
            slot_id:slot.slot_id,
            toy_id:0,
            howlong_mili:this.config.general.tent_toy_howlong_mili
        };
       
       
       customer.moveToPos({pos_end:slot.pos},function(){
           var i,bum,toy_all=[],obj,howmany_rand=0,row,toy_blocked={};
                
            for(i in thc.tentSlots){
                bum=thc.tentSlots[i];
                if(isNumeric(bum.blocked) && bum.blocked>0){
                    toy_blocked[bum.blocked]=1;
                }
            }



            for(i in thc.config.toysConfig){
                bum=thc.config.toysConfig[i];
                obj=thc.objects["toy"+bum.toy_id];
                row={toy_id:bum.toy_id,howlong:obj.takeBusyHowlong()};
                if(typeof toy_blocked[bum.toy_id]!="undefined"){
                    row.howlong+=2000;
                }
                if(row.howlong==0){
                    howmany_rand++;
                }
                toy_all.push(row);
            }
            toy_all.sort(function(a,b){
               return a.howlong-b.howlong; 
            });
            if(howmany_rand>0){
                to_set.toy_id=toy_all[mt_rand(0,howmany_rand-1)].toy_id;
            }
            else{
                to_set.toy_id=toy_all[0].toy_id;
            }
            customer.setTent(to_set);
       });
        
    },
    customerDecide:function(customer){
        customer.win();
        
        var slot_ava=[];
        var i,bum;
        for(i in this.tentSlots){
            bum=this.tentSlots[i];
            if(bum.blocked==0){
                slot_ava.push(i);
            }
        }
        if(this.storage.tutorial_arr.length==0 && slot_ava.length>0 && mt_rand(1,100)<=this.config.general.tent_chance){
            var slot=this.tentSlots[slot_ava[mt_rand(0,slot_ava.length-1)]];
            this.customerTent(customer,slot);
        }
        else{
            this.customerScore(customer);
        }
        
        this.customersSlots[customer.config.slot_id].blocked=0;
        
        
        
        
        
        
        this.addCustomer();
    },
    findIceId:function(key,val){
        var i,bum;
        for(i in this.config.iceConfig){
            bum=this.config.iceConfig[i];
            if(in_array(val,bum[key])){
                return bum.ice_id;
            }
        }
        return 0;
    },
    clickOnObject:function (obj) {
        var thc = this;
        var type=obj.takeType();
        if(this.storage.state=="tutorial"){
            var need=this.storage.tutorial_need;
            var prep={ice:["factory","add"]};
            if(typeof prep[need.type]!="undefined"){
                if(!in_array(type,prep[need.type])){
                    return false;
                }
            }
            else if(type!=need.type){
                return false;
            }
        }

        if(type=="factory"){
            this.clickFactory(obj);
        }else if(type=="toy"){
          this.clickToy(obj);
        }
        else if(type=="add"){
            this.clickAdd(obj);
        }
        return 1;
    },
    onCustomerDone:function (customer) {

    },
    gameEndTrigger:function() {
        if (this.statesAll.isGameEnd() && this.customers.length == 0) {
            this.statesAll.blockGame(1);
        }
    },
    moveObject:function (object,posStart,posEnd,onEnd) {
      var masterThc = this;
      var obj = new myPixiObj.drawCustom({
          pos_start:posStart,
          pos_end:posEnd,
          v:10,
          anim_type:"object",
          object:object,
          onEndAnim:function(){
              onEnd.call(object);
          }
      });

      return obj;
    },
    myDestruct:function (th) {
      if(typeof th.app!="undefined" && typeof th.app.destroy()!="undefined" ){
        th.app.destroy();
      }
      // console.log(this.app.destroy());
      // for(var i in this.customers){
      //   var c = this.customers[i];
      //   c.destroy();
      // }
    },
    setTouch:function (div) {
        var thc = this;
        function isObjectClicked(arr) {
            var i,k,obj,pos;
            for(k in arr){
                pos=arr[k];
                for(i in thc.objects) {
                    obj = thc.objects[i];
                    if(obj.isClick(pos)) {
                        thc.clickOnObject(obj);
                    }
                }
                for(i in thc.iceArr){
                    obj=thc.iceArr[i];
                    if(obj.isClick(pos)){
                        thc.clickOnIce(obj);
                    }
                }
            }
        }

        new addTouch(div[0],{
            onStart:function (arr) {
                isObjectClicked(arr);
            },
            onEnd:function (arr) {
                isObjectClicked(arr);
            },
            onMouseDown:function (arr) {
                isObjectClicked(arr);
            }
        });
    },
    myUpdate:function (delta) {
        var i,bum,ret;
        this.sortClients(0);
        
        if(this.storage.state=="game"){
            for(i in this.customers){
                bum = this.customers[i];
                bum.update(delta);
            }
            this.timerBox.update(delta);
            this.tentSet.update(delta);
            this.cumSet.update(delta);
        }
        else if(this.storage.state=="tutorial"){
            this.tutorialArrow.myUpdate(delta);
        }
        
        
        for(i in this.objects){
            bum = this.objects[i];
            bum.update(delta);
        }
        //this.otherAnim
        var active;
        for(i=this.otherAnim.length-1;i>=0;i--){
            active=this.otherAnim[i].update(delta);
            if(!active){
                this.otherAnim[i].remove();
                this.otherAnim.splice(i,1);
            }
        }
        for(i=this.iceArr.length-1;i>=0;i--){
            active=this.iceArr[i].myUpdate(delta);
            if(!active){
                this.iceArr[i].remove();
                this.iceArr.splice(i,1);
            }

        }
        
        this.delta_sum+=delta;
        
        if(this.storage.timeout && this.customers.length==0){
            this.endGameNow();
            
        }
        
    },
    endGameNow:function(){
        if(this.state.tutorial){
            return false;
        }
        var res={
            type:"win",
            points:this.state.points,
            points_need:this.state.points_need,
            reason_id:0,
            heart:this.comboBox.takeHeart(),
            howlong_remain:this.timerBox.takeTimeRemain(),
        };
        if(this.state.was_cum>0){
            res.type="lose";
            res.reason_id=2;
        }
        else if(this.state.points<this.state.points_need){
            res.type="lose";
            res.reason_id=1;
        }
        
        this.statesAll.endGame(res);
        this.app.ticker.stop();
        return true;
    },
    clearCustomerHandlerIndex: function () {
        if(this.addCustomerHandlerIndex!==null){
        _moduleTimeHandler.clear(this.addCustomerHandlerIndex);
        }
    },
    updateCombo:function (val) {
      // if (val===0) {
      //   this.comboVal = 0;
      // }
      // this.comboVal+=val;
    },
    countPointsEarn:function(customerId) {
        var customerConfig = this.config['customersConfig'][customerId], cash=0;

        if (typeof customerConfig === "undefined") {
          return 0;
        }
        var count = mt_rand(customerConfig['cash']['min'],customerConfig['cash']['max']);

        this.pointsAllEarned += count;
        this.customersAll += 1;
        return count;
    },
};
